import config, { isEnabled } from 'Config';
import { DEFAULT_CHECK } from 'Lib/constants/detection';

import { LAYOUT_DESKTOP, LAYOUT_MOBILE } from 'Store/commonActions';
import { BIOMETRICS_NOT_REQUIRED_STATE } from 'Store/userBiometrics/constants';

import { mobileDesktopBreakpointQuery } from 'Components/MediaQuery';

import { ThemeId, type AppSettingsState } from './types';

const getMatchesLayout = (mediaQuery: any) => (mediaQuery.matches ? LAYOUT_DESKTOP : LAYOUT_MOBILE);

const initialState: AppSettingsState = {
  appStartInfo: DEFAULT_CHECK, // default
  ageVerificationStatus: 'not_needed',
  ageVerificationReason: 0,
  ageVerificationIsSessionOnboardingSkippable: false,
  ageVerificationShowSessionOnboardingModal: false,
  distanceUnit: config.distanceUnit,
  biometricConsents: [],
  biometricLivenessState: BIOMETRICS_NOT_REQUIRED_STATE,
  canEditEmail: false,
  chatSuggestionConsents: [],
  companyMaxLength: 128,
  consent: null,
  emailVerificationDismissible: true,
  emailVerificationRequired: false,
  globalPassportTitle: '',
  globalPassportDescription: '',
  chatSuggestionConsentShown: false,
  isBiometricConsentNeeded: true,
  isConsumablesEnabled: isEnabled('consumables'),
  isGoldEnabled: isEnabled('gold'),
  isHubbleDebuggerEnabled: false,
  isPlatinumEnabled: isEnabled('platinum'),
  isMessageConsentNeeded: false,
  isTermsAcceptanceNeeded: false,
  isTinderPlusEnabled: isEnabled('tinderPlus'),
  jobTitleMaxLength: 128,
  // default mobile layout server side
  layout: __CLIENT__ ? getMatchesLayout(mobileDesktopBreakpointQuery) : LAYOUT_MOBILE,
  merchandisingFeatures: null,
  messageConsents: [],
  orientationEnabled: null,
  orientations: [],
  paywallFeatures: [],
  platinumPaywallFeatures: [],
  recsToolbarIsOpened: true,
  schoolMaxLength: 128,
  showTerms: false,
  superBoostMembersText: '',
  superlikeAlcMode: 2,
  termsVersion: null,
  themeDevicePreference: ThemeId.Light,
  themePreference: null,
  typingPulseInterval: config?.typingIndicator?.pulse,
  typingTimeout: config?.typingIndicator?.ttl,
};

export default initialState;
